// Generated by /client/scripts/generate-icon-components.mjs
// DO NOT EDIT DIRECTLY

import type React from "react";

import settings01Icon from "@/assets/icons/settings-01.svg";

import { Icon, type IconProps } from "../Icon/Icon";

type Settings01IconProps = Omit<IconProps, "name">;

export function Settings01Icon(props: Settings01IconProps): React.ReactNode {
  return <Icon name={settings01Icon} {...props} />;
}
